// Treasure Collect – micro-animations (see tc-motion.css).
// Add to cart: the product photo flies along an arc into the header cart, the cart bounces with a gold burst,
// then the cart drawer opens as usual. Plus: a tick on the quick-add button (the gold buttons' hover is CSS only).
(() => {
  if (window.tcMotion) return;
  window.tcMotion = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));
  let pending = null; // what was just added: source photo + button

  // ---------- where the added product comes from ----------
  const visibleImg = (scope) => {
    if (!scope) return null;
    return [...scope.querySelectorAll('img')].find((im) => {
      const r = im.getBoundingClientRect();
      return r.width > 60 && r.height > 60 && r.bottom > 0 && r.top < innerHeight && getComputedStyle(im).visibility !== 'hidden';
    }) || null;
  };

  document.addEventListener('submit', (e) => {
    const pf = e.target.closest && e.target.closest('product-form');
    if (!pf) return;
    let card = pf.closest('.tc-home__product');
    let button = pf.querySelector('[type=submit]');
    const modal = pf.closest('quick-add-modal');
    if (modal && modal.id) {
      const opener = document.querySelector(`modal-opener[data-modal="#${modal.id}"]`);
      if (opener) { card = opener.closest('.tc-home__product'); button = opener.querySelector('button') || button; }
    }
    const scope = pf.closest('.main-product-template, .product, section');
    const img = visibleImg(card) || visibleImg(modal) || visibleImg(scope);
    // photo scrolled out of view (long product page): fly the product photo out of the button instead
    let photo = null;
    if (!img) {
      const any = [...((card || scope || document).querySelectorAll('img'))].find((im) => im.naturalWidth > 150 && /products|files/.test(im.currentSrc || im.src));
      if (any) photo = any.currentSrc || any.src;
    }
    pending = { img, photo, button, from: button, time: Date.now() };
  }, true);

  // ---------- the flight ----------
  const cartIcon = () => {
    const el = document.querySelector('#cart-icon-bubble');
    if (!el) return null;
    const r = el.getBoundingClientRect();
    return r.width && r.bottom > 0 && r.top < innerHeight ? { el, x: r.left + r.width / 2, y: r.top + r.height / 2 } : null;
  };

  const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

  const burst = (x, y) => {
    const ring = document.createElement('span');
    ring.className = 'tc-ring';
    ring.style.left = x + 'px'; ring.style.top = y + 'px';
    document.body.appendChild(ring);
    ring.animate([{ transform: 'scale(.3)', opacity: 0.9 }, { transform: 'scale(1.9)', opacity: 0 }], { duration: 650, easing: 'cubic-bezier(.16,1,.3,1)' }).onfinish = () => ring.remove();
    const n = 10;
    for (let i = 0; i < n; i++) {
      const s = document.createElement('span');
      s.className = 'tc-spark' + (i % 3 === 0 ? ' tc-spark--coin' : '');
      s.style.left = x + 'px'; s.style.top = y + 'px';
      document.body.appendChild(s);
      const a = (i / n) * Math.PI * 2 + Math.random() * 0.5;
      const d = 26 + Math.random() * 26;
      const dx = Math.cos(a) * d, dy = Math.sin(a) * d;
      s.animate([
        { transform: 'translate(0,0) scale(.2) rotate(0deg)', opacity: 1 },
        { transform: `translate(${dx * 0.75}px,${dy * 0.75}px) scale(1.15) rotate(90deg)`, opacity: 1, offset: 0.55 },
        { transform: `translate(${dx}px,${dy + 10}px) scale(.3) rotate(160deg)`, opacity: 0 }
      ], { duration: 700 + Math.random() * 250, easing: 'cubic-bezier(.16,1,.3,1)' }).onfinish = () => s.remove();
    }
  };

  const hitCart = (cart) => {
    cart.el.classList.remove('tc-cart-hit');
    void cart.el.offsetWidth;
    cart.el.classList.add('tc-cart-hit');
    setTimeout(() => cart.el.classList.remove('tc-cart-hit'), 800);
    burst(cart.x, cart.y);
  };

  const fly = async (src) => {
    const cart = cartIcon();
    if (!cart) return;
    let r, w, h;
    if (src.img) {
      r = src.img.getBoundingClientRect();
      const side = Math.min(220, Math.max(r.width, r.height));
      w = Math.min(r.width, side); h = Math.min(r.height, side);
    } else if (src.photo && src.from && src.from.getBoundingClientRect().width) {
      r = src.from.getBoundingClientRect();
      w = h = 110;
    } else { hitCart(cart); await wait(250); return; }
    const sx = r.left + r.width / 2, sy = r.top + r.height / 2;
    const el = document.createElement('div');
    el.className = 'tc-fly';
    el.style.width = w + 'px'; el.style.height = h + 'px';
    const pic = document.createElement('img');
    pic.className = 'tc-fly__img';
    pic.src = src.img ? (src.img.currentSrc || src.img.src) : src.photo;
    pic.alt = '';
    el.appendChild(pic);
    document.body.appendChild(el);
    // quadratic arc: up and over, landing in the cart
    const cx = (sx + cart.x) / 2 + (cart.x - sx) * 0.15;
    const cy = Math.min(sy, cart.y) - Math.max(120, Math.abs(cart.x - sx) * 0.25);
    const steps = 30, frames = [];
    for (let i = 0; i <= steps; i++) {
      const t = ease(i / steps), u = 1 - t;
      const x = u * u * sx + 2 * u * t * cx + t * t * cart.x;
      const y = u * u * sy + 2 * u * t * cy + t * t * cart.y;
      const k = i / steps;
      const scale = 1 - 0.86 * Math.pow(t, 1.4) + (k < 0.15 ? Math.sin(k / 0.15 * Math.PI) * 0.06 : 0);
      frames.push({ transform: `translate(${x - w / 2}px,${y - h / 2}px) rotate(${-10 * Math.sin(t * Math.PI)}deg) scale(${scale})`, opacity: k > 0.88 ? 1 - (k - 0.88) / 0.12 * 0.7 : 1 });
      // sparkle trail
      if (i > 2 && i < steps - 2 && i % 3 === 0) {
        const dot = document.createElement('span');
        dot.className = 'tc-fly__trail';
        dot.style.left = x + 'px'; dot.style.top = y + 'px'; dot.style.opacity = 0;
        document.body.appendChild(dot);
        dot.animate([{ opacity: 0, transform: 'scale(.4)' }, { opacity: 0.9, transform: 'scale(1.2)', offset: 0.2 }, { opacity: 0, transform: 'scale(.2) translateY(8px)' }],
          { duration: 600, delay: (i / steps) * 760, easing: 'ease-out' }).onfinish = () => dot.remove();
      }
    }
    const anim = el.animate(frames, { duration: 780, easing: 'linear', fill: 'forwards' });
    await anim.finished.catch(() => {});
    el.remove();
    hitCart(cart);
    await wait(260);
  };

  const tick = (button) => {
    if (!button || !button.classList.contains('tc-home__quick-add')) return;
    const t = document.createElement('span');
    t.className = 'tc-tick';
    t.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
    button.appendChild(t);
    button.classList.add('tc-added');
    setTimeout(() => { button.classList.remove('tc-added'); t.remove(); }, 1600);
  };

  const popCount = () => {
    const b = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!b) return;
    b.classList.remove('tc-count-pop');
    void b.offsetWidth;
    b.classList.add('tc-count-pop');
  };

  const markNew = (state) => {
    const id = state && (state.variant_id || state.id);
    if (!id) return;
    const row = document.querySelector(`cart-drawer .cart-item[data-id="${id}"]`);
    if (row) { row.classList.add('tc-new'); setTimeout(() => row.classList.remove('tc-new'), 2200); }
  };

  // run the flight just before the theme opens its cart drawer (it would cover the cart icon)
  const patch = (name) => customElements.whenDefined(name).then(() => {
    const C = customElements.get(name);
    if (!C || C.prototype.tcPatched) return;
    const orig = C.prototype.renderContents;
    C.prototype.tcPatched = true;
    C.prototype.renderContents = function (state) {
      const src = pending && Date.now() - pending.time < 15000 ? pending : null;
      pending = null;
      const finish = () => { orig.call(this, state); popCount(); markNew(state); };
      if (!src || reduce.matches) { finish(); return; }
      tick(src.button);
      fly(src).then(finish, finish);
    };
  });
  patch('cart-drawer');
  patch('cart-notification');

  // ---------- cart: removed line slides out, quantity number bumps, subtotal counts to its new value ----------
  document.addEventListener('click', (e) => {
    if (reduce.matches) return;
    const rm = e.target.closest && e.target.closest('cart-remove-button');
    if (rm) {
      const row = rm.closest('.cart-item');
      if (row) row.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateX(48px)' }], { duration: 320, easing: 'cubic-bezier(.4,0,1,1)', fill: 'forwards' });
      return;
    }
    const q = e.target.closest && e.target.closest('.quantity__button');
    if (q) {
      const input = q.parentElement && q.parentElement.querySelector('input');
      if (input) input.animate([{ transform: 'none' }, { transform: `translateY(${q.name === 'plus' ? -6 : 6}px) scale(1.18)`, color: '#f7b218', offset: 0.35 }, { transform: 'none' }], { duration: 380, easing: 'cubic-bezier(.34,1.56,.64,1)' });
    }
  }, true);

  // money text -> number and back, keeping the shop's own format ("CHF 1'234.50", "19,95 CHF", ...)
  const parseMoney = (t) => {
    const m = t.match(/\d[\d'’.,\s]*\d|\d/);
    if (!m) return null;
    const raw = m[0];
    const dec = /[.,]\d{2}$/.test(raw) ? raw.slice(-3, -2) : null;
    const digits = raw.replace(/[^\d]/g, '');
    const value = dec ? parseInt(digits, 10) / 100 : parseInt(digits, 10);
    const thou = (raw.slice(0, dec ? -3 : undefined).match(/[^\d]/) || [''])[0];
    return { value, dec, thou, before: t.slice(0, m.index), after: t.slice(m.index + raw.length) };
  };
  const formatMoney = (f, v) => {
    const cents = f.dec ? Math.round(v * 100) : Math.round(v);
    let int = String(f.dec ? Math.floor(cents / 100) : cents);
    if (f.thou) int = int.replace(/\B(?=(\d{3})+(?!\d))/g, f.thou);
    return f.before + int + (f.dec ? f.dec + String(cents % 100).padStart(2, '0') : '') + f.after;
  };
  const seenTotals = new WeakSet();
  let prevSubtotal = null;
  const countUp = (el) => {
    const now = parseMoney(el.textContent.trim());
    if (!now) return;
    const from = prevSubtotal;
    prevSubtotal = now.value;
    if (from === null || from === now.value || reduce.matches) return;
    el.textContent = formatMoney(now, from);   // start from the old amount right away (no flash of the new one)
    const t0 = performance.now(), dur = 650;
    const step = (t) => {
      const k = Math.min(1, (t - t0) / dur), e2 = 1 - Math.pow(1 - k, 3);
      el.textContent = formatMoney(now, from + (now.value - from) * e2);
      if (k < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
    el.animate([{ color: '#f7b218' }, { color: getComputedStyle(el).color }], { duration: 900, easing: 'ease-out' });
  };
  const firstSubtotal = document.querySelector('.totals__subtotal-value');
  if (firstSubtotal) { seenTotals.add(firstSubtotal); const f = parseMoney(firstSubtotal.textContent.trim()); if (f) prevSubtotal = f.value; }

  // ---------- product page: the price slides in when the variant changes ----------
  const animatePrice = (el) => {
    if (reduce.matches) return;
    el.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 420, easing: 'cubic-bezier(.16,1,.3,1)' });
  };

  // one observer for everything the theme re-renders
  new MutationObserver((list) => {
    for (const m of list) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        const sub = n.matches('.totals__subtotal-value') ? n : n.querySelector('.totals__subtotal-value');
        if (sub && !seenTotals.has(sub)) { seenTotals.add(sub); countUp(sub); }
        const box = n.closest('.main-product-template [id^="price-"]');
        if (box && (!box.tcAnim || Date.now() - box.tcAnim > 300)) { box.tcAnim = Date.now(); animatePrice(box); }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // ---------- checkout: no show, straight to the secure checkout; the button only shows it is on its way ----------
  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (btn && !btn.disabled) btn.classList.add('tc-going');
  }, true);
  window.addEventListener('pageshow', () => document.querySelectorAll('.tc-going').forEach((b) => b.classList.remove('tc-going')));

  // ---------- search panel: a picture of the first design for each popular search (once, when it opens) ----------
  let thumbs = false;
  const loadThumbs = () => {
    if (thumbs) return;
    thumbs = true;
    const base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    document.querySelectorAll('.tc-search__pop[data-term]').forEach((a) => {
      const slot = a.querySelector('.tc-search__thumb');
      fetch(`${base}.json?q=${encodeURIComponent(a.dataset.term)}&resources[type]=product&resources[limit]=1`)
        .then((r) => r.json())
        .then((d) => {
          const p = d && d.resources && d.resources.results && d.resources.results.products && d.resources.results.products[0];
          const src = p && ((p.featured_image && p.featured_image.url) || p.image);
          if (!src || !slot) return;
          const img = new Image();
          img.alt = '';
          img.decoding = 'async';
          img.onload = () => { slot.appendChild(img); slot.classList.add('has-img'); };
          img.src = src + (src.includes('?') ? '&' : '?') + 'width=120';
        })
        .catch(() => {});
    });
  };
  document.addEventListener('click', (e) => { if (e.target.closest && e.target.closest('#dT_TopStickySearchBtn, .header__search')) loadThumbs(); });

  // ---------- newsletter signed up: gold burst on the thank-you line ----------
  const nlOk = document.querySelector('[id^="tc-newsletter-success-"]');
  if (nlOk && !reduce.matches) {
    setTimeout(() => { const r = nlOk.getBoundingClientRect(); if (r.width && r.top < innerHeight && r.bottom > 0) burst(r.left + r.width / 2, r.top + r.height / 2); nlOk.classList.add('tc-nl-ok'); }, 700);
  }

  // ---------- back to top: coins jump out of the chest ----------
  document.addEventListener('click', (e) => {
    const top = e.target.closest && e.target.closest('#to-top');
    if (!top || reduce.matches) return;
    const r = top.getBoundingClientRect();
    burst(r.left + r.width / 2, r.top + r.height * 0.6);
  });

  // ---------- titles ([data-tc-words], product titles): the words rise out of a soft blur one after another ----------
  const splitWords = (el) => {
    if (el.dataset.tcWordsDone) return;
    el.dataset.tcWordsDone = '1';
    let w = 0;
    const walk = (node) => {
      [...node.childNodes].forEach((child) => {
        if (child.nodeType === 3) {
          const frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            const s = document.createElement('span');
            s.className = 'tc-word';
            s.style.setProperty('--w', w++);
            s.textContent = part;
            frag.appendChild(s);
          });
          child.replaceWith(frag);
        } else if (child.nodeType === 1 && child.tagName !== 'BR') {
          if (!child.children.length && !/\s/.test(child.textContent.trim())) { child.classList.add('tc-word'); child.style.setProperty('--w', w++); }
          else walk(child);
        }
      });
    };
    walk(el);
    el.classList.add('tc-words');
  };
  if (!reduce.matches && 'IntersectionObserver' in window) {
    const wordsIO = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); wordsIO.unobserve(e.target); }
    }), { threshold: 0.2 });
    const scanWords = () => document.querySelectorAll('[data-tc-words], h1.tc-product-title').forEach((el) => {
      if (el.dataset.tcWordsDone) return;
      splitWords(el);
      wordsIO.observe(el);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scanWords); else scanWords();
  }

  // ---------- Shopify's theme preview bar covers the bottom of the screen in previews: the cart drawer keeps clear
  // of it (--tc-pbar, used by tc-overlays.css). On the live shop there is no bar and the value stays 0. ----------
  const pbar = () => {
    const b = document.getElementById('PBarNextFrameWrapper');
    let h = 0;
    if (b) { const r = b.getBoundingClientRect(); if (r.height && r.top < window.innerHeight) h = Math.round(window.innerHeight - r.top); }
    if (h > window.innerHeight / 3) h = 0;
    document.documentElement.style.setProperty('--tc-pbar', h + 'px');
    return b;
  };
  let pbarTries = 0;
  const pbarWait = setInterval(() => {
    const b = pbar();
    if (b && window.ResizeObserver) { new ResizeObserver(pbar).observe(b); clearInterval(pbarWait); }
    else if (++pbarTries > 20) clearInterval(pbarWait);
  }, 800);
  window.addEventListener('resize', pbar, { passive: true });

  // ---------- cart icon: a gentle ping on arrival when the cart already holds something ----------
  window.addEventListener('load', () => {
    const b = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (b && !b.classList.contains('count-zero') && /[1-9]/.test(b.textContent) && !reduce.matches) setTimeout(() => b.classList.add('tc-count-ping'), 900);
  });

})();
